import { observer } from "mobx-react-lite";
import { useBurgerModalOfficeItems } from "./hooks/useBurgerModalOfficeItems";
import { useUserTypeDetection } from "./hooks/useUserTypeDetection";
import { getOfficeItems, getSuperAdminItems } from "./config/menuItemsConfig";
import { FoldersMenuSection } from "./components/FoldersMenuSection";
import { OfficeMenuSection } from "./components/OfficeMenuSection";
import { CommonMenuSection } from "./components/CommonMenuSection";
import classes from "./classes.module.scss";

type IProps = {
	isOpen: boolean;
	closeModal: () => void;
};

const BurgerModal = observer(function BurgerModal(props: IProps) {
	const { isOpen } = props;

	const officeMenuCandidates = useBurgerModalOfficeItems(getOfficeItems(), isOpen);
	const superAdminItems = getSuperAdminItems();

	const { isClientOrThirdParty, isSuperAdmin } = useUserTypeDetection();

	if (!isOpen) return null;

	return (
		<div className={classes["root"]} data-testid="header-openable-panel" data-openable="burger">
			{!isClientOrThirdParty && (
				<>
					<FoldersMenuSection />
					<OfficeMenuSection
						officeMenuCandidates={officeMenuCandidates}
						isSuperAdmin={isSuperAdmin}
						superAdminItems={superAdminItems}
					/>
				</>
			)}

			<CommonMenuSection isClientOrThirdParty={isClientOrThirdParty} />
		</div>
	);
});

export default BurgerModal;
